var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microphone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44 17a12 12 0 1 1 -12-12 12 12 0 0 1 12 12zm15 32a10.1 10.1 0 1 1 -10.09-10.09 10.09 10.09 0 0 1 10.09 10.09zm-4 0a1 1 0 0 0 -1-1h-4v-4a1 1 0 0 0 -2 0v4h-4a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 1-1zm-18.19 0a12.11 12.11 0 0 1 11.72-12.08 17.12 17.12 0 0 0 -4.53-2.17c-.47-.15-.94-.26-1.42-.37l-.42-.08c-.38-.07-.76-.12-1.15-.17l-.45-.05c-.51 0-1-.08-1.56-.08h-14c-.53 0-1.05 0-1.56.08l-.45.05c-.39 0-.77.1-1.15.17l-.41.08c-.49.11-1 .22-1.43.37a17 17 0 0 0 -12 16.25 8 8 0 0 0 8 8h26.11a12.11 12.11 0 0 1 -5.3-10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAccount);
export default __webpack_public_path__ + "static/media/newAccount.4d57f656688b97085e6a1fadfd770645.svg";
export { ForwardRef as ReactComponent };